import { WebDevelopmentPage } from './WebDevelopmentPage';

export default WebDevelopmentPage;
